export const AUTH_TYPE = {
  LOGIN: "login",
  SIGNUP: "signup",
};
